const state = {
  fetching: 'fetching',
  error: 'error',
  success: 'success'
}


export default state